import { ReactElement, useState } from 'react';
import CustomLink from '@components/CustomLink';
import { getUrl, IDENTIFIERS } from '@helpers/urlsHelper';
import ProgressIndicator from '@/components/ProgressIndicator';
import { ArrowRight } from '@phosphor-icons/react';
import s from './HandbookPdfContainer.module.scss';

type Props = {
  creatorSlug: string;
  productSlug: string;
  productId: string;
  productTitle: string;
  productDescription: string;
  isActive: boolean;
};

const HandbookCard = ({ creatorSlug, productSlug, productId, productTitle, productDescription, isActive }: Props): ReactElement => {
  const [clickedByte, setClickedByte] = useState<string | null>(null);

  return (
    <CustomLink
      to={getUrl(IDENTIFIERS.PRODUCT, { creatorSlug, productSlug })}
      onClick={() => setClickedByte(productId)}
      className={s.handbookPdfCard}
      key={productId}
      style={(clickedByte === productId && { backgroundColor: 'var(--color-gray-25)' }) || {}}
    >
      <h1 className={s.handbookPdfCard__title}>{productTitle}</h1>

      {productDescription && <p className={s.handbookPdfCard__description}>{productDescription}</p>}

      <div className={s.handbookPdfCard__seeAll}>
        See all
        <>{clickedByte ? <ProgressIndicator color="var(--color-primary)" /> : <ArrowRight size={16} />}</>
      </div>

      {!isActive && <div className={s.inactive}>Inactive</div>}
    </CustomLink>
  );
};

export default HandbookCard;
